import React from "react";
 
export default function TemplateMonster() {
  return null;
}
